'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _Constants = require('ui-addon-avatars/Constants');

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _Images = require('../visitor-widget/constants/Images');

var _ChatHeadingAvatars = require('./components/ChatHeadingAvatars');

var _ChatHeadingAvatars2 = _interopRequireDefault(_ChatHeadingAvatars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'InitialMessageBubble',

  propTypes: {
    chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
    chatHeadingResponders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
    initialMessage: _react.PropTypes.string.isRequired,
    mobile: _react.PropTypes.bool.isRequired,
    onClick: _react.PropTypes.func.isRequired,
    onClose: _react.PropTypes.func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      mobile: false
    };
  },
  renderAvatar: function renderAvatar() {
    var _props = this.props,
        chatHeadingConfig = _props.chatHeadingConfig,
        chatHeadingResponders = _props.chatHeadingResponders,
        mobile = _props.mobile,
        onClick = _props.onClick;


    var avatarHeightPx = mobile ? _Constants.AVATAR_SIZES.sm : _Constants.AVATAR_SIZES.md;
    return _react2.default.createElement(
      'div',
      {
        className: 'initial-message-avatar',
        onClick: onClick,
        style: {
          top: -avatarHeightPx / 2
        }
      },
      _react2.default.createElement(_ChatHeadingAvatars2.default, {
        chatHeadingConfig: chatHeadingConfig,
        chatHeadingResponders: chatHeadingResponders,
        mobile: mobile
      })
    );
  },
  renderCloseButton: function renderCloseButton() {
    return _react2.default.createElement(
      _UIButton2.default,
      {
        className: 'initial-message-close-button',
        use: 'unstyled',
        size: 'extra-small',
        responsive: false,
        onClick: this.props.onClose
      },
      _react2.default.createElement(_UIIcon2.default, { name: 'remove' })
    );
  },
  render: function render() {
    var _props2 = this.props,
        initialMessage = _props2.initialMessage,
        onClick = _props2.onClick;


    return _react2.default.createElement(
      'div',
      { className: 'initial-message-bubble' },
      this.renderCloseButton(),
      this.renderAvatar(),
      _react2.default.createElement(
        'p',
        {
          className: 'initial-message-text m-top-1 m-bottom-0',
          onClick: onClick
        },
        initialMessage
      ),
      _react2.default.createElement(_UIImage2.default, {
        className: 'initial-message-bubble-tail',
        src: _Images.initialMessageBubbleTail
      })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/InitialMessageBubble.js
// module id = 1189
// module chunks = 2 3